enum MuiColors {
  DEFAULT = 'default',
  SECONDARY = 'secondary',
  PRIMARY = 'primary',
}
export default MuiColors
